import { Switch as BaseSwitch } from '@base-ui/react/switch';
import type { ComponentProps } from 'react';
import { cx } from '../lib/styled.tsx';

export type SwitchProps = ComponentProps<typeof BaseSwitch.Root>;

/**
 * Root + thumb in one component: the thumb carries no choices of its own, so
 * exposing it would only let callers break the track's geometry.
 */
export function Switch({ className, ...props }: SwitchProps) {
  return (
    <BaseSwitch.Root
      className={cx(
        'relative inline-flex h-6 w-10 shrink-0 items-center rounded-full p-0.5',
        'border border-border-subtle bg-surface',
        'transition-colors duration-150 ease-out-quint',
        // The track takes the brand colour itself, not the deeper step the
        // small indicators use — this is a surface, and coral is a fill.
        'data-checked:border-brand-400 data-checked:bg-brand-400',
        'data-disabled:cursor-not-allowed data-disabled:border-ink-faint data-disabled:bg-border-subtle',
        className,
      )}
      {...props}
    >
      <BaseSwitch.Thumb
        className={cx(
          'size-[18px] rounded-full bg-surface-raised shadow-knob',
          'transition-[translate] duration-150 ease-out-quint data-checked:translate-x-4',
        )}
      />
    </BaseSwitch.Root>
  );
}
